export default {
  "models": {
    "remark": "notes",
  },

  "farms": {
    "plural": "farms",
    "singular": "farm",
  },
  "ponds": {
    "plural": "ponds",
    "singular": "pond",
  },
  "cycles": {
    "plural": "cycles",
    "singular": "cycle",
  },

  "cyclePredictions": {
    "plural": "predictions",
    "singular": "prediction",

    "age": "DoC",
    "weight": "MBW (g)",
    "total_weight": "biomass (kg)",
    "survival_rate": "SR (%)",
    "size": "count",
    "selling_price": "price",

    "pond": "pond",
    "today": "today",
    "total": "total"
  },
  "cycleActuals": {
    "plural": "actuals",
    "singular": "actual"
  },

  "shrimpPrices": {
    "plural": "shrimp prices",
    "singular": "shrimp price",

    "size": "count",
  },

  "multiMeasurements": {
    "plural": "multi measurements",
    "singular": "multi measurement",

    "id": "ID",
    "pond_id": "pond ID",
    "cycle_id": "cycle ID",
    "measured_at": "measured at",

    "ph": "pH",
    "salinity": "salinity",
    "temperature": "temperature",
    "do": "dissolved oxygen",
    "transparency": "transparency",
    "water_level": "water level",
    "do_percent": "dissolved oxygen percent",
    "ec": "electrical conductivity",
    "tds": "total dissolves solids",
    "gravity": "sea water specific gravity",
    "color": "color",
    "weather": "weather",
    "turbidity": "turbidity",
    "tom": "total organic matter",
    "ammonia": "ammonia",
    "ammonium": "ammonium",
    "total_ammonia": "total ammonia",
    "nitrit": "nitrite",
    "nitrat": "nitrate",
    "phosphate": "phosphate",
    "bicarbonat": "bicarbonate",
    "carbonat": "carbonate",
    "alkalinity": "alkalinity",
    "magnesium": "magnesium",
    "calcium": "calcium",
    "hardness": "hardness",
    "potassium": "potassium / kalium",
    "orp": "oxidation-reduction potential",
    "ga": "green algae",
    "bga": "blue green algae",
    "dino": "dinoflagellata",
    "diatom": "diatom",
    "euglenophyta": "euglenophyta",
    "haptyophyta": "haptyophyta",
    "gba": "gold brown algae",
    "gga": "golden green algae",
    "yga": "yellow green algae",
    "floc": "floc",
    "prozoo": "protozoa",
    "zoo": "zoo",
    "total_plankton": "total plankton",
    "yellow": "yellow vibrio",
    "green": "green vibrio",
    "luminance": "luminance",
    "black": "black vibrio",
    "total_vibrio": "total vibrio",
    "total_bacteria": "total bacteria",

    "temperature_short": "temp",
    "salinity_short": "sal",
    "do_short": "DO",
    "ammonia_short": "NH3",
    "nitrat_short": "NO3",
    "nitrit_short": "NO2",
    "alkalinity_short": "alkalinity",
    "hardness_short": "hardness",
    "calcium_short": "Ca",
    "magnesium_short": "Mg",
    "carbonat_short": "CO3",
    "bicarbonat_short": "HCO3",
    "tom_short": "TOM",
    "orp_short": "ORP",
    "ammonium_short": "NH4",
    "phosphate_short": "PO4",
    "total_ammonia_short": "total NH3",
    "potassium_short": "potassium",
    "total_plankton_short": "total plankton",
    "ga_short": "GA",
    "bga_short": "BGA",
    "dino_short": "Dino",
    "diatom_short": "diatom",
    "prozoo_short": "prozoo",
    "floc_short": "floc",
    "gba_short": "GBA",
    "euglenophyta_short": "euglenophyta",
    "zoo_short": "zoo",
    "haptyophyta_short": "haptyophyta",
    "gga_short": "GGA",
    "yga_short": "YGA",
    "total_bacteria_short": "total bacteria",
    "total_vibrio_short": "total vibrio",
    "yellow_short": "yellow",
    "green_short": "green",
    "black_short": "black",
    "luminance_short": "luminance",

    "measured_date": "date",
    "measured_time": "time",

    "cycle": "cycle",
    "pond": "pond",
    "farm": "farm",

    "waterQuality": "water quality",
    "chemical": "chemical",
    "plankton": "plankton",
    "microbiology": "microbiology"
  },
  "waterQualityMultiMeasurements": {
    "plural": "water quality",
    "singular": "water quality"
  },
  "chemicalMultiMeasurements": {
    "plural": "chemical",
    "singular": "chemical"
  },
  "planktonMultiMeasurements": {
    "plural": "plankton",
    "singular": "plankton"
  },
  "microbiologyMultiMeasurements": {
    "plural": "microbiology",
    "singular": "microbiology"
  },
  "feeds": {
    "plural": "feeds",
    "singular": "feed",

    "id": "ID",
    "cycle_id": "cycle ID",
    "stock_id": "stock ID",
    "quantity": "quantity (kg)",
    "logged_at": "logged at",
    "remark": "notes",

    "feed_at": "feed at",
    "logged_date": "date",
    "logged_time": "time",
    "accumulation": "accumulation (kg)",
    "age": "age",
    "fasting": "fasting",

    "accumulation_short": "accum. (kg)",
    "remark_short": "note",

    "cycle": "cycle",
    "pond": "pond",
    "farm": "farm",
    "stock": "stock"
  },
  "fastings": {
    "plural": "fastings",
    "singular": "fasting",

    "id": "ID",
    "cycle_id": "cycle ID",
    "logged_date": "date",
    "fasting": "fasting",
    "remark": "notes",

    "cycle": "cycle",
    "pond": "pond",
    "farm": "farm"
  },
  "feedingTrayControls": {
    "plural": "feeding trays",
    "singular": "feeding tray",

    "id": "ID",
    "logged_at": "logged at",
    "feed_logged_at": "feed logged at",
    "cycle_id": "cycle ID",
    "tray_number": "tray number",
    "feed_remaining_percent": "feed remaining percent",
    "remark": "notes",

    "logged_time": "time",
    "logged_date": "date",
    "remark_short": "note",

    "tray": "tray",
    "empty": "empty",
    "empty_short": "E",
    "few": "few",
    "few_short": "F",
    "plenty": "plenty",
    "plenty_short": "P",
  },
  "samplings": {
    "plural": "samplings",
    "singular": "sampling",

    "id": "ID",
    "cycle_id": "cycle ID",
    "average_weight": "MBW (g)",
    "survival_rate": "survival rate",
    "sampled_at": "date",
    "remark": "notes",

    "average_growth": "ADG",
    "adg": "ADG",
    "remark_short": "note"
  },
  "treatments": {
    "plural": "treatments",
    "singular": "treatment",

    "id": "ID",
    "pond_id": "pond ID",
    "stock_id": "stock ID",
    "name": "name",
    "quantity": "quantity",
    "treated_at": "treated at",
    "remark": "notes",

    "remark_short": "note"
  },
  "harvests": {
    "plural": "harvests",
    "singular": "harvest",

    "id": "ID",
    "cycle_id": "cycle ID",
    "weight": "weight (kg)",
    "size": "size",
    "harvested_at": "date",
    "selling_price": "selling price",
    "status": "type",
    "remark": "notes",
    "buyer": "buyer",

    "price_per_kg": "price per kg",
    "total_price": "total price",

    "weight_short": "weight",
    "remark_short": "note"
  },
  "mortalities": {
    "plural": "mortalities",
    "singular": "mortality",

    "id": "ID",
    "cycle_id": "cycle ID",
    "quantity": "quantity",
    "average_weight": "average weight",
    "recorded_at": "date",
    "remark": "notes",

    "size": "size",
    "total_weight": "weight (kg)",

    "total_weight_short": "weight",
    "remark_short": "note"
  },
  "cycleDiseases": {
    "plural": "diseases",
    "singular": "disease",

    "id": "ID",
    "cycle_id": "cycle ID",
    "disease_id": "disease ID",
    "laboratory_id": "laboratory ID",
    "other_disease": "other disease",
    "logged_at": "logged at",
    "positive": "positive",
    "remark": "notes",

    "logged_date": "date",
    "logged_time": "time",
    "image": "photo",

    "remark_short": "note",

    "disease": "disease"
  },

  "regions": {
    "plural": "regions",
    "singular": "region",

    "outside_indonesia": "OUTSIDE INDONESIA"
  },

  "autoFeederPond": {
    "plural": "auto feeder ponds",
    "singular": "auto feeder pond",

    "id": "ID",
    "pond_id": "pond ID",
    "auto_feeder_address": "address",
    "name": "name",
    "mode": "mode",
    "debit": "debit",
    "state": "state",

    "ip": "IP",
    "startTime": "start time",
    "endTime": "end time",
    "onTime": "timer ON",
    "feeds": "feeds",
    "updatedAt": "updated at",
    "uploadedAt": "uploaded at",
    "lastOnAt": "last ON at",

    "timesPerDay": "times per day",
    "timesPerPeriod": "throw times per feeding",
    "intervalPerPeriod": "interval per period",
    "intervalPeriod": "feed duration",

    "feedsPerDay": "feeds per day",

    "updated": "updated",
    "uploaded":"uploaded",
    "created": "created"
  },
}
